import './App.less'
import { ConfigProvider } from 'antd';
import { useRoutes } from "react-router-dom";
import { ACCOUNT_ROUTERS } from './pages/pages.router';

function App() {

  const router = useRoutes(ACCOUNT_ROUTERS)
  
  return (
    <ConfigProvider componentSize="middle">
      {router}
    </ConfigProvider>
  );
}

export default App;
